import { NgModule } from '@angular/core';
import {
  MatLargeIconButtonDirective,
  MatMediumIconButtonDirective,
  MatSmallIconButtonDirective,
  MatTinyIconButtonDirective,
} from '@libs/shared/styles/mat-icon-button/mat-icon-button-sizes-directive';

@NgModule({
  declarations: [
    MatLargeIconButtonDirective,
    MatMediumIconButtonDirective,
    MatSmallIconButtonDirective,
    MatTinyIconButtonDirective,
  ],
  imports: [],
  exports: [
    MatLargeIconButtonDirective,
    MatMediumIconButtonDirective,
    MatSmallIconButtonDirective,
    MatTinyIconButtonDirective,
  ],
})
export class MatIconButtonSizesModule {}
